export default __webpack_public_path__ + "static/media/Elko.491a20a9.png";